import ResourceService from './resource.service'

class GarageService extends ResourceService {
  static get resource() {
    return 'garage'
  }
}

export default GarageService
